import React from 'react';
import { PageContext } from '@xingternal/pages-common';
import { useServerData } from '@xingternal/hops';

export type ModulesLoadedState = {
  [key: string]: boolean;
};

const useModulesLoaded = (pageModulesByType: string[] | null) => {
  const { pageContext, setPageContext } = React.useContext(PageContext);
  const { authenticated } = useServerData();

  const setModuleLoaded = (type: string) => {
    setPageContext((prevState) =>
      prevState
        ? {
            ...prevState,
            modulesLoaded: { ...(prevState.modulesLoaded || {}), [type]: true },
          }
        : undefined
    );
  };

  const canDisplayModule = (type: string) => {
    if (!authenticated) {
      return true;
    }

    if (!pageModulesByType || !pageContext) {
      return false;
    }

    for (let i = 0; pageModulesByType[i] !== type; i++) {
      if (
        typeof pageContext.modulesLoaded === 'undefined' ||
        !pageContext.modulesLoaded[pageModulesByType[i]]
      ) {
        return false;
      }
    }
    return true;
  };

  return [canDisplayModule, setModuleLoaded];
};

export { useModulesLoaded };
